import { InteractionRequiredAuthError, PublicClientApplication, SilentRequest } from '@azure/msal-browser';
import { loginRequest, msalConfig } from '~/auth-config';

export const isTokenExpired = (token) => {
  const expirationTime = new Date(token.expiresOn).getTime();
  const currentTime = new Date().getTime();

  return expirationTime < currentTime;
};

export const getAccessToken = async () => {
  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();
  const userAccount = msalInstance.getActiveAccount();
  if (!userAccount) return;
  // If you register GraphQL Api as different application, pass in the registed scopes here
  const accessTokenRequest: SilentRequest = {
    account: userAccount,
    ...loginRequest,
  };
  try {
    const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
    return response.accessToken;
  } catch (error) {
    console.log('Silent token acquisition fails. Acquiring token using popup. \n', error);
    if (error instanceof InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      return msalInstance.acquireTokenRedirect(accessTokenRequest);
    } else {
      console.log(error);
    }
  }
};
